import { useRef, useEffect } from "react";
import { AiMessageBubble } from "./ai-message-bubble";
import { UserMessageBubble } from "./user-message-bubble";
import { TypingIndicator } from "./typing-indicator";
import type { ChatMessage } from "@/services/chat-service";

interface ChatMessageListProps {
  messages: ChatMessage[];
  isLoading?: boolean;
}

export function ChatMessageList({ messages, isLoading }: ChatMessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="flex flex-1 flex-col gap-6 overflow-y-auto py-10 lg:px-[160px]">
      {messages.map((msg) =>
        msg.role === "assistant" ? (
          <AiMessageBubble key={msg.id} content={msg.content} />
        ) : (
          <UserMessageBubble key={msg.id} content={msg.content} />
        ),
      )}
      {isLoading && <TypingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
}
